



























































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import BaseVue from "@/core/BaseVue";
import TipoTramiteComponentProp from "@/helpers/tipoTramiteComponentProp.helper";
import { PropOptions } from "vue";
import Miembro from "../../models/miembro/miembro.model";
import BTableConfig from "@/core/BTableConfig/BTableConfig";
import TramiteBeneficiario from "@/models/tramite/tramiteBeneficiario.model";
import SolicitudRc from "@/models/tramite/solicitud-reporte-comunitario/solicitudRc.model";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import Hogar from "@/models/hogar/hogar.model";
import Direccion from "@/models/direccion.model";
import Persona from "@/models/persona/persona.model";
import SituacionRc from "@/models/reporteComunitario/situacionRc.model";

@Component
export default class SolicitudReporteComunitario extends BaseVue {
  @Prop() readonly solicitante!: Persona;
  @Prop() readonly content!: TramiteBeneficiario;
  private mostrarActividades: boolean = false;
  private paramsOfActivities = "actividadRcPadreId=null";
  model = new SolicitudRc();

  get personaId() {
    if (this.solicitante && this.solicitante.id) return this.solicitante.id;
    return 0;
  }

  created() {
    // let props = [];
    // props.push(new TipoTramiteComponentProp("cedula", "string"));
    this.$emit("render", []);
  }
  destroyed() {
    if (this.content) {
      let contenido = this.content as any;
      if (contenido.solicitudRc) delete contenido.solicitudRc;
      this.$emit("update:content", contenido);
    }
  }

  @Watch("model.servicioRcId")
  onServicioRcIdChange() {
    if (this.model.servicioRcId) {
      this.mostrarActividades = false;
      setTimeout(() => {
        this.paramsOfActivities = `actividadRcPadreId=null&ServicioRcId=${this.model.servicioRcId}`;
        this.mostrarActividades = true;
      }, 0.001);
    } else {
      this.mostrarActividades = false;
    }
  }

  @Watch("model", { deep: true })
  set(model: SolicitudRc) {
    if (this.content) {
      let contenido = this.content as any;
      contenido.solicitudRc = this.map<SolicitudRc>(this.model);
      this.$emit("update:content", contenido);
    }
  }

  @Watch("model.actividadRcId")
  actividadChange(id: number | undefined) {
    if (id) {
      this.getAllSituaciones();
    }
  }
  loadingSituacion = false;
  situaciones: SituacionRc[] = [];
  situacionesSeleccionadas: SituacionRc[] = [];
  @Watch("situacionesSeleccionadas", { deep: true })
  onSituacionesChange(values: SituacionRc[]) {
    if (values && values.length == 0) {
      this.model.situacionesSeleccionadas = undefined;
      return;
    }
    this.model.situacionesSeleccionadas = values.map(x => x.nombre).join(";");
  }

  addNuevaSituacion(newTag: string) {
    const tag = {
      nombre: newTag
    } as any;

    this.situaciones.push(tag);
    this.situacionesSeleccionadas.push(tag);
  }

  async getAllSituaciones() {
    this.loadingSituacion = true;
    let repo = new BaseRepository<SituacionRc>(`SituacionRc`);
    this.situaciones = await repo.search(
      `actividadRcId=${this.model.actividadRcId}`
    );
    this.loadingSituacion = false;
  }
}
